import { useContext } from 'react'

import { AdminCanUpdateContext } from './AdminCanUpdateContext'

export const useAdminCanUpdate = () => useContext(AdminCanUpdateContext)
